export default __webpack_public_path__ + "static/media/check-2.0c3d3c6f.svg";